import { render, staticRenderFns } from "./assignRes.vue?vue&type=template&id=e61f9c1c"
import script from "./assignRes.vue?vue&type=script&lang=js"
export * from "./assignRes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports